<style lang="scss" scoped>
  @import "./review.scss";
</style>
<script>
import CartItems from '../cart-items/cart-items.vue'
import TransactionBillingInfo from '../transaction-billing-info/transaction-billing-info'
import TransactionPaymentInfo from '../transaction-payment-info/transaction-payment-info'
import TransactionShippingInfo from '../transaction-shipping-info/transaction-shipping-info'
import TokenPaymentInfo from '../token-payment-info/token-payment-info'
import consumer from '../../utils/consumer'
import sharedService from '../../utils/shared-service'
import traceService from '../../components/shared/trace/trace-service'
import { mapGetters } from 'vuex'
import messages from '../../messages.js'
import toasterService from '../../utils/toaster.js'

export default {
  name: 'Review',
  components: {
    CartItems,
    TransactionBillingInfo,
    TransactionPaymentInfo,
    TransactionShippingInfo,
    TokenPaymentInfo
  },

  data () {
    return {
      payloadResponse: this.reviewDetails(),
      cartDetails: JSON.parse(localStorage.getItem('cartDetails')),
      confirmationRequest: {},
      billingAddress: (this.reviewDetails().maskedCard || {}).billingAddress || {},
      shippingAddress: (this.reviewDetails().maskedCard || {}).shippingAddress || {}
    }
  },

  computed: {
    ...mapGetters(['srcCorrelationId', 'srcNetwork', 'consumerJwt', 'saveMaskCard']),

    isLoggedIn: function () {
      return this.consumerJwt
    }
  },

  created () {
    if (!this.cartDetails || Object.keys(this.$store.getters.products).length === 0) {
      this.$router.push('/cart').catch(err => { console.error(err) })
    }
  },

  methods: {
    /**
       * This method routes to account page
       */
    goToAccountPage () {
      this.$router.push('/account').catch(err => { console.error(err) })
    },

    reviewDetails () {
      setTimeout(() => {
        sharedService.updateCheckoutButton(false)
      }, 2000)
      const decryptedData = consumer.getDecryptedData()
      return consumer.getPayloadResponse(decryptedData)
    },

    async gotoConfirmationPage () {
      try {
        let response = await sharedService.confirmation(this.srcCorrelationId, this.srcNetwork)
        traceService.updateCallTraces(this.srcNetwork, response.callTraces, true)
        this.$router.push('/confirm').catch(err => { console.error(err) })
      } catch (error) {
        sharedService.confirmationData(this.srcCorrelationId, this.srcNetwork).then(
          response => {
            this.confirmationRequest = response
            let errorLog = error.response.data.callTraces || sharedService.serviceDownError(this.srcNetwork, error, this.confirmationRequest, messages['en-US'].errorMessages.SERVICE_DOWN_ERROR.CONFIRMATION)
            toasterService.onFailure(messages['en-US'].errorMessages.CONFIRMATION_ERROR)
            traceService.updateCallTraces(this.srcNetwork, errorLog, false)
          })
      }
    }
  }
}
</script>

<template>
  <div
    class="container"
    data-test="review"
  >
    <div class="row pt-4">
      <div class="col">
        <h3>
          {{ $t('header.cart') }}
        </h3>
      </div>
      <div
        class="col"
      >
        <small
          v-if="!isLoggedIn"
          class="pull-right text-muted text-right">
          {{ $t('label.returnCustomer') }}
          <button
            id="sign-in"
            class="btn btn-primary btn-lg ml-2"
            type="button"
            @click="goToAccountPage()"
          >
            {{ $t('label.signIn') }}
          </button>
        </small>
      </div>
    </div>
    <div class="border-dark border-top my-2" />
    <div class="row">
      <div class="col-xs-12 col-sm-6 mt-5">
        <h4 class="font-weight-bold pl-md-3">
          {{ $t ('header.reviewOrder') }}
        </h4>
        <div class="pl-md-3">
          <cart-items :cart-details="cartDetails" />
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 mt-4 pl-md-5 mt-5">
        <div
          v-if="!payloadResponse.token"
          id="transaction-payment-info"
          class="mb-3"
        >
          <transaction-payment-info :masked-card="payloadResponse.maskedCard || {}" />
        </div>
        <div
          v-if="payloadResponse.token"
          id="token-payment-info"
          class="mb-3"
        >
          <token-payment-info :masked-token="payloadResponse.maskedToken || {}" />
        </div>
        <hr>
        <transaction-billing-info
          :masked-billing-address="billingAddress"
          :masked-consumer="payloadResponse.maskedConsumer || {}"
        />
        <hr>
        <transaction-shipping-info
          :masked-consumer="payloadResponse.maskedConsumer || {}"
          :masked-shipping-address="shippingAddress"
          :payload-response="payloadResponse"
        />
        <button
          id="confirm-btn"
          class="btn btn-primary btn-lg pull-right my-5 mr-md-4"
          @click="gotoConfirmationPage"
        >
          {{ $t ('label.placeOrder') }}
        </button>
      </div>
    </div>
  </div>
</template>
